
export default function Lifestyle() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.15em] text-[#8A8A8A] mb-4 sm:mb-6">
              LIFESTYLE
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4 sm:mb-6">
              Build Your Daily Discipline
            </h2>
            <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed mb-6 sm:mb-8">
              Success isn't built in a day. It's built in the small, consistent actions you take every night. 
              Our strap is designed to fit seamlessly into your routine, working while you rest.
            </p>
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              {[
                'Comfortable for 8+ hours of wear',
                'Adjustable fit for all head sizes',
                'Premium breathable materials',
                'Easy to clean and maintain'
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-2 sm:gap-3">
                  <i className="ri-checkbox-circle-fill text-base sm:text-lg text-black"></i>
                  <span className="text-xs sm:text-sm text-[#6B6B6B]">{item}</span>
                </div>
              ))}
            </div>
            <a
              href="#products"
              className="inline-flex items-center gap-2 bg-black text-white h-11 sm:h-12 px-6 sm:px-8 rounded-full text-xs sm:text-sm font-medium hover:bg-black/90 transition-all cursor-pointer whitespace-nowrap"
            >
              Start Your Journey
              <i className="ri-arrow-right-line text-base sm:text-lg"></i>
            </a>
          </div>

          {/* Right - Image */}
          <div>
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-white">
              <img
                src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/504629c5dabfd483aaac01ecd34bcb3b.png"
                alt="Daily Routine"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
